// extracted by mini-css-extract-plugin
export default {"QuizCreator":"QuizCreator_QuizCreator__60Z+F"};